/* eslint-disable max-len */
import React from "react";
import { useBookingAppointmentTypeStore } from "../../hooks";
import { CREATE_BOOKING_TYPE } from "../../config/params";
import { ForwardArrowIcon } from "../Icons";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { userActivityLogger } from "../../utils/mixpanel";


const BookingTypeToggleCard = () => {
  const {
    bookingAppointmentType,
    setBookingAppointmentType,
    setDefaultBookingType,
  } = useBookingAppointmentTypeStore();
  const { setAppointmentsForm, selectedPets } = useAppointmentStore();

  const handleBookingAvailabilityCheck = () => {
    setAppointmentsForm(null);
    if (bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING) {
      setDefaultBookingType();
      userActivityLogger(MIXPANEL_EVENTS.USER_SWITCH_TO_IN_ROOM_VISIT, {
        pet_name: selectedPets.map((pet) => pet.name).join(","),
        referred_from_page: "reschedule",
      });
    } else {
      setBookingAppointmentType(CREATE_BOOKING_TYPE.DROPOFF_BOOKING);
      userActivityLogger(
        MIXPANEL_EVENTS.USER_SWITCH_TO_DROP_OFF,
        {
          pet_name: selectedPets.map((pet) => pet.name).join(","),
          referred_from_page: "reschedule",
        },
      );
    }
  };

  return (
    <div className="p-3 bg-white border border-gray-3 flex justify-between gap-1.5 rounded-lg cursor-pointer"
      onClick={handleBookingAvailabilityCheck}>

      {(bookingAppointmentType !== CREATE_BOOKING_TYPE.DROPOFF_BOOKING) ?
        <div className="text-sm">
            Prefer to<span className="font-semibold"> Drop-Off </span>your pet?
        </div> :
        <div className="text-sm">
            Prefer a<span className="font-semibold"> Doctor Visit?</span>
        </div>
      }
      <div className="flex gap-1 cursor-pointer">
        <div className="font-semibold text-sm text-mustard">Check Availability</div>
        <div className="flex items-center"><ForwardArrowIcon width={14} height={14} fill={"#AE8305"} /></div>
      </div>
    </div>
  );
};

export default BookingTypeToggleCard;
